// WM Shipment Scheduling — Pick Capacity Slots API calls.
//
// Plain axios rather than a DevExtreme CustomStore: the popup re-reads a whole day at a time. Going
// through axios also means the shared response interceptor in AppContainer.js handles auth and
// concurrency failures the same way as every other screen.
//
// PROPERTY CASING: PickCapacityController returns through plain Ok(...), so responses serialize with
// the global camelCase naming. Read camelCase here.

import axios from 'axios';
import routes from '../../../../../assets/apiRoutes.json';

const authHeaders = (accessToken) => ({
    headers: {
        'Content-Type': 'application/json',
        access_token: accessToken,
    },
});

// `keys` is repeated per value so the ASP.NET model binder fills List<Guid>.
const keyQuery = (keys) => (keys || []).map((k) => `keys=${encodeURIComponent(k)}`).join('&');

// The local calendar date as yyyy-MM-dd. JSON/ISO serialization of a Date is a UTC instant, which
// can land on the previous day for anyone behind UTC and silently show the wrong day's slots.
const localDate = (day) => {
    if (!day) return null;
    if (typeof day === 'string') return day.slice(0, 10);
    const p = (n) => String(n).padStart(2, '0');
    return `${day.getFullYear()}-${p(day.getMonth() + 1)}-${p(day.getDate())}`;
};

export const GetPickCapacityDay = (accessToken, keys, day) => {
    const dayPart = day ? `&day=${localDate(day)}` : '';
    return axios.get(
        `${window._env_.REACT_APP_APIS}/${routes.PickCapacity.GetPickCapacityDay}?${keyQuery(keys)}${dayPart}`,
        authHeaders(accessToken),
    );
};

export const ApplyToSlot = (accessToken, payload) =>
    axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.PickCapacity.ApplyToSlot}`,
        payload,
        authHeaders(accessToken),
    );

// Carrier codes for the popup's Carrier dropdown — the existing WM ship-via lookup, already used by
// wm/components/consignee/AddConsignee.js. It returns LookupDTO { id, name } where `id` is the
// IDMASTER row id, which is exactly what WMTRANSACTIONHEADER.R_CARRIER stores, and `name` is the
// "code - name" label. Bind valueExpr="id" / displayExpr="name".
export const GetCarriers = (accessToken) =>
    axios.get(
        `${window._env_.REACT_APP_APIS}/${routes.Carrier.GetShipVia}`,
        authHeaders(accessToken),
    );
